import { render } from "./QRGenerator.vue?vue&type=template&id=0c2cc1f1&scoped=true&ts=true"
import script from "./QRGenerator.vue?vue&type=script&lang=ts"
export * from "./QRGenerator.vue?vue&type=script&lang=ts"

import "./QRGenerator.vue?vue&type=style&index=0&id=0c2cc1f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Rogerio\\devel\\pixPrinter\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c2cc1f1"]])

export default __exports__